import { createFileRoute } from '@tanstack/react-router';
import { ApiKeys } from '@/components/api-keys';
import { Integrations } from '@/components/integrations';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/integrations',
)({
  component: IntegrationsSettings,
});

function IntegrationsSettings() {
  return (
    <PageContent>
      <div className="space-y-6">
        {/* Project keys lead the page — every integration option below uses
            them. (Moved here from the old Automations → API Keys page.) */}
        <ApiKeys />
        <Integrations />
      </div>
    </PageContent>
  );
}
